
function TarifRate() {
    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">
                        <div class="card">
                            <div class="card-body">
                                <h5>Tarif Rate</h5>
                                <br />
                                <div class="live-preview">
                                    <form action="javascript:void(0);">
                                        <div class="row">

                                            <div class="col-md-3">
                                                <div >
                                                    <label for="productname-field" class="form-label">Tarif Rate</label>
                                                    <div class="row">

                                                        <div class="col-md-12">
                                                            <input type="text" class="form-control" placeholder="Enter Tarif Rate" id="firstNameinput" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div >
                                                    <label for="productname-field" class="form-label">Charge Type</label>
                                                    <select class="form-control" data-trigger="" name="productname-field" id="productname-field">
                                                        <option value="Rs">Rs</option>
                                                        <option value="%">%</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Category</label>
                                                    <input type="text" class="form-control" placeholder="Enter Category" id="firstNameinput" />
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">Rate %</label>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <input type="text" class="form-control" placeholder="Enter Rate" id="firstNameinput" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="col-md-12">
                                                <br /><br />
                                            </div>
                                            <div class="col-md-2">
                                            <div class="card-body pt-0">
                                                    <div>

                                                        <div class="table-responsive table-card mb-1">
                                                            <table class="table table-nowrap align-middle" id="orderTable">
                                                                <thead class="text-muted table-light" >
                                                                    <tr class="text-uppercase">
                                                                        <th data-sort="id">Module Name</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody class="list form-check-all">
                                                                    <tr>
                                                                        <td class="customer_name">Doctor</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class="customer_name">Ward</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class="customer_name">Room</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class="customer_name">IPD Package</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="card-body pt-0">
                                                    <div>

                                                        <div class="table-responsive table-card mb-1">
                                                            <table class="table table-nowrap align-middle" id="orderTable">
                                                                <thead class="text-muted table-light" >
                                                                    <tr class="text-uppercase">
                                                                        <th scope="col">
                                                                            <div class="form-check">
                                                                                <input class="form-check-input" id="checkAll" type="checkbox" value="option" />
                                                                            </div>
                                                                        </th>
                                                                        <th data-sort="id">S. No.</th>
                                                                        <th data-sort="customer_name">Code</th>
                                                                        <th data-sort="product_name">Details</th>
                                                                        <th data-sort="product_name">Rate</th>
                                                                        <th data-sort="product_name">PISN</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody class="list form-check-all">
                                                                    <tr>
                                                                        <th scope="row">
                                                                            <div class="form-check">
                                                                                <input class="form-check-input" type="checkbox" value="option1" name="checkAll" />
                                                                            </div>
                                                                        </th>
                                                                        <td class="customer_name">1.</td>
                                                                        <td class="product_name">3423423</td>
                                                                        <td class="date">HARBINDER SINGH</td>
                                                                        <td class="date"><input type="number" class="form-control" value="2"/></td>
                                                                        <td class="date"><input type="number" class="form-control" value="0002"/></td>
                                                                       
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <div class="noresult">
                                                                <div class="text-center">
                                                                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c"></lord-icon>
                                                                    <h5 class="mt-2">Sorry! No Result Found</h5>
                                                                    <p class="text-muted">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TarifRate;
